export const surveyResponses = {
  NotAvailable: "Not Available",
  intakeSurvey: {
    title: "Intake survey",
    description:
      "Intake survey responses help create a more personalized plan for the {{patientTerm}}",
    questions: {
      patient_status: "{{patientTerm}} status",
      health_goals: "Health goals",
      symptoms: "Current symptoms",
      physical_activities: "Activity types",
      activity_frequency: "Physical activity frequency",
      typical_weekday: "Activity level",
      dietary_preferences: "Dietary preferences",
      family_medical_history: "Family medical history",
      supplements_medications: "Current supplements/medications",
      height: "Height",
      weight: "Weight",
      existing_health_conditions: "Existing health conditions",
      smoking_status: "Smoking status",
      allergies_or_sensitivities: "Allergies or sensitivities",
      surgeries: "Surgeries",
    },
    answers: {
      // Patient Status
      current_patient: "Current patient",
      past_patient: "Past patient",
      never_been_patient: "Never been patient",

      // Health Goals
      confirm_right_track: "Staying on track",
      understand_root_causes: "Understand symptoms",
      proactive_prevention: "Prevent issues",
      optimize_wellbeing: "Optimize health",

      // Symptoms
      fatigue: "Fatigue",
      insomnia_disrupted_sleep: "Sleep issues",
      headaches_migraines: "Headaches",
      digestion_issues: "Digestion issues",
      anxiety_mood_swings: "Anxiety/mood",
      depressed_mood_low_motivation: "Depression/low motivation",
      chronic_stress: "Chronic stress",
      brain_fog_difficulty_concentrating: "Brain fog",
      hot_flashes_night_sweats: "Hot flashes",
      unexplained_weight_gain: "Weight issues",
      low_libido_sexual_health_changes: "Sexual health changes",
      joint_pain_muscle_stiffness: "Joint/muscle pain",
      hair_thinning_loss: "Hair loss",
      dry_skin_brittle_nails: "Skin/nail issues",
      irregular_heavy_periods: "Period irregularities",

      // Physical Activities
      cardio_endurance: "Cardio & endurance",
      strength_resistance_training: "Strength training",
      low_impact: "Low impact",
      outdoor_activities: "Outdoor activities",
      sports: "Sports",
      dance: "Dance",
      everyday_movement: "Everyday movement",

      // Activity Frequency
      none: "None",
      one_to_two_days: "1-2 days",
      three_to_five_days: "3-5 days",
      five_to_seven_days: "5-7 days",

      // Typical Weekday
      mostly_sedentary: "Mostly sedentary",
      moderately_active: "Moderately active",
      physically_active: "Physically active",
      highly_active: "Highly active",

      // Dietary Preferences
      dairy_free: "Dairy-free",
      gluten_free: "Gluten-free",
      paleo: "Paleo",
      keto: "Keto",
      vegetarian: "Vegetarian",
      vegan: "Vegan",
      low_carb: "Low-carb",
      mediterranean: "Mediterranean",
      none_of_the_above: "None",

      // Family Medical History
      heart_disease: "Heart disease",
      high_blood_pressure: "High blood pressure",
      diabetes: "Diabetes",
      stroke: "Stroke",
      cancer: "Cancer",
      kidney_disease: "Kidney disease",
      mental_health_disorders: "Mental health",
      thyroid_conditions: "Thyroid conditions",
      autoimmune_diseases: "Autoimmune diseases",

      // Allergies
      no_allergies_or_sensitivities: "No allergies",
      peanuts: "Peanuts",
      tree_nuts: "Tree nuts",
      milk: "Milk",
      lactose: "Lactose",
      eggs: "Eggs",
      wheat: "Wheat",
      soy: "Soy",
      shellfish: "Shellfish",
      fish: "Fish",
      sesame: "Sesame",
      corn: "Corn",
      gelatin: "Gelatin",
      oats: "Oats",
      gluten: "Gluten",
      sunflower_seeds: "Sunflower seeds",
      poppy_seeds: "Poppy seeds",
      lentils_legumes: "Lentils / Legumes",

      // Health conditions
      no_existing_health_conditions: "No existing health conditions",
      high_cholesterol: "High cholesterol",
      diabetes_type_2: "Diabetes (Type 2)",
      depression: "Depression",
      anxiety: "Anxiety",
      hypothyroidism: "Hypothyroidism",
      obesity: "Obesity",
      acid_reflux_gerd: "Acid reflux / GERD",
      asthma: "Asthma",
      irritable_bowel_syndrome: "Irritable Bowel Syndrome (IBS)",
      arthritis: "Arthritis",
      insulin_resistance_prediabetes: "Insulin resistance / Prediabetes",

      // Smoking status
      do_not_smoke: "I do not smoke",
      current_smoker: "I am a current smoker",
      previous_smoker: "I used to smoke, but have since quit",

      // Supplements/Medications
      yes: "Yes",
      no: "No",

      // Common
      other: "Other",
    },
  },
  womensHormonesSurvey: {
    title: "Women's hormones survey",
    description:
      "Women's hormones survey responses help create a more personalized plan for the {{patientTerm}}",
    questions: {
      period_recency: "Last period timing",
      period_regularity: "Cycle regularity",
      last_period_start_date: "Last period start date",
      next_period_start_date: "Next period expected",
      birth_control_type: "Current birth control method",
      birth_control_brand: "Birth control brand",
      birth_control_start_date: "Birth control start date",
      menopause_diagnosis: "Peri/menopause diagnosis",
    },
    answers: {
      // Period Recency
      within_3_months: "Within 3 months",
      within_12_months: "Within 12 months",
      more_than_12_months: "More than 12 months",

      // Period Regularity
      regular: "Regular",
      irregular: "Irregular",

      // Birth Control Type
      none: "None",
      hormonal: "Hormonal",
      non_hormonal: "Non-hormonal",
      surgical: "Surgical",

      // Birth Control Brand
      un_sure: "Unsure",

      // Menopause Diagnosis
      no: "No",
      peri_menopause: "Peri-menopause",
      post_menopause: "Post-menopause",

      // Common
      other: "Other",
    },
  },
};
